import { Wallet, TrendingUp, ArrowDownRight } from "lucide-react";

const ron = (n) => `${Number(n || 0).toLocaleString("ro-RO", { maximumFractionDigits: 0 })} RON`;

export default function CashflowCard({ data }) {
  if (!data) return null;
  const rows = [
    { label: "Revenue azi",      value: data.revenue_today, accent: "text-foreground", icon: TrendingUp },
    { label: "COD expected",     value: data.cod_expected, sub: `${data.cod_orders || 0} comenzi`, accent: "text-amber-600" },
    { label: "Card revenue",     value: data.card_revenue, sub: `${data.card_orders || 0} comenzi`, accent: "text-sky-600" },
    { label: "Ad spend",         value: data.ad_spend, accent: "text-rose-600", icon: ArrowDownRight },
    { label: "Costuri operare",  value: data.ops_cost, accent: "text-zinc-600" },
    { label: "Taxe estimate",    value: data.tax, accent: "text-zinc-600" },
  ];
  return (
    <div className="rounded-xl border border-border bg-white p-5" data-testid="cashflow-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Wallet className="h-4 w-4 text-emerald-600" />
          <h3 className="font-display font-semibold text-base">Revenue & Cashflow · Azi</h3>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Profit net azi</div>
          <div className="font-display text-2xl font-bold tabular-nums text-emerald-600">{ron(data.profit_today)}</div>
          {data.margin_pct != null && (
            <div className="text-[10px] text-muted-foreground tabular-nums">margin {Number(data.margin_pct).toFixed(1)}%</div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {rows.map((r) => (
          <div key={r.label} className="rounded-lg border border-border bg-zinc-50 px-3 py-3">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{r.label}</div>
            <div className={`font-display text-base font-bold mt-1 tabular-nums ${r.accent}`}>{ron(r.value)}</div>
            {r.sub && <div className="text-[10px] text-muted-foreground mt-0.5">{r.sub}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
